import {CurrentSale} from "../../../../../store/api/interface/demo";
import {Box, Button, DialogActions} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {theme} from "../../../../../_fri/themes/theme";
import {useNavigate} from "react-router-dom";
import {Transaction} from "../../../../../store/api/interface/ecommerce";

interface IModalPaymentSuccess{
    close:()=>void,
    transaction:Transaction
}
export const EcommerceDashboardModalPaymentSuccess = ({close, transaction}:IModalPaymentSuccess) => {
    const navigate = useNavigate();
    const onClick=()=>{
        close();
        navigate('/ecommerce/voucher',{state: {data: transaction}})
    }


    return (
        <>
            <Box sx={{marginTop: "2rem", marginBottom: "0.7rem"}}>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <CheckCircleIcon color='success' sx={{fontSize:"7rem"}}/>
                </Box>
                <Box sx={{flexGrow: 1, fontSize: "1rem", justifyContent: "center", display: "flex"}}>
                    <Box sx={{textAlign: "center", color: theme.palette.common.black}}>
                        <Box>
                            Pago realizado
                        </Box>
                    </Box>
                </Box>
            </Box>
            <DialogActions sx={{justifyContent: "center", marginBottom: "1rem"}}>
                <Button
                    sx={{
                        width: "6.5rem",
                        height: "3rem",
                        borderRadius: "0.5rem",
                    }}
                    color={"success"}
                    variant={"contained"}
                    onClick={onClick}
                >
                    Aceptar
                </Button>
            </DialogActions>
        </>
    );
};